import { render, staticRenderFns } from "./VerProductoVenta.vue?vue&type=template&id=60467f76&scoped=true&"
import script from "./VerProductoVenta.vue?vue&type=script&lang=js&"
export * from "./VerProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60467f76",
  null
  
)

export default component.exports